<template>
  <div class="container mx-auto px-4 overflow-x-auto">
    <div v-if="loading">
      <AppLoding />
    </div>

    <!-- Contenedor de filtros -->
    <!-- <div class="flex flex-col md:flex-row justify-between items-center gap-4 mb-4">
      <input
        v-model="searchQuery"
        type="text"
        placeholder="Buscar..."
        class="w-full md:w-1/2 p-3 rounded-md bg-gray-600 text-white border border-gray-500 focus:ring-2 focus:ring-orange-500"
      />
      <select
        v-model="filterCategory"
        class="w-full md:w-auto mt-2 md:mt-0 p-3 rounded-md bg-gray-600 text-white border border-gray-500 focus:ring-2 focus:ring-orange-500"
      >
        <option value="">Todas las categorías</option>
        <option
          v-for="category in uniqueCategories"
          :key="category"
          :value="category"
        >
          {{ category }}
        </option>
      </select>
    </div> -->

    <!-- Contenedor de botones debajo -->
    <div class="flex flex-col gap-2 mb-4">
      <button
        @click="sincronizarProductos()"
        class="w-full bg-green-500 text-white px-4 py-2 rounded"
      >
        Sincronizar productos minorista
      </button>

      <button
        @click="pdfProductos()"
        class="w-full bg-orange-500 text-white px-4 py-2 rounded"
      >
        PDF productos minorista
      </button>

      <button
        @click="sincronizarProductosMayorista()"
        class="w-full bg-green-500 text-white px-4 py-2 rounded"
      >
        Sincronizar productos mayorista
      </button>

      <button
        @click="pdfProductosMayorista()"
        class="w-full bg-orange-500 text-white px-4 py-2 rounded"
      >
        PDF productos mayorista
      </button>
    </div>

    <!-- <div class="overflow-x-auto mb-4">
      <table class="min-w-full bg-gray-800 text-white">
        <thead>
          <tr>
            <th
              class="py-2 px-4 border-b border-gray-700 cursor-pointer"
              @click="sortTable('categoria')"
            >
              Categoría
            </th>
            <th
              class="py-2 px-4 border-b border-gray-700 cursor-pointer"
              @click="sortTable('nombre')"
            >
              Nombre
            </th>
            <th
              class="py-2 px-4 border-b border-gray-700 cursor-pointer"
              @click="sortTable('precio')"
            >
              Precio
            </th>
            <th class="py-2 px-4 border-b border-gray-700">Acciones</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in filteredItems" :key="index">
            <td class="py-2 px-4 border-b border-gray-700">
              {{ item.categoria }}
            </td>
            <td class="py-2 px-4 border-b border-gray-700">
              {{ item.nombre }}
            </td>
            <td class="py-2 px-4 border-b border-gray-700">
              ${{ item.precio }}
            </td>
            <td class="py-2 px-4 border-b border-gray-700">
              <div class="flex space-x-2">
                <button
                  @click="openModal(item, index)"
                  class="text-blue-400 hover:text-blue-600"
                >
                  <i class="fa-solid fa-pen"></i>
                </button>
                <button
                  @click="deleteItem(index)"
                  class="text-red-400 hover:text-red-600"
                >
                  <i class="fa-solid fa-trash"></i>
                </button>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div> -->

    <!-- Modal para Agregar/Editar Producto -->
    <div
      v-if="showModal"
      class="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50"
    >
      <div class="bg-gray-800 p-6 rounded shadow-lg w-96">
        <h2 class="text-white text-lg mb-4">
          {{ editingIndex === null ? "Agregar Producto" : "Editar Producto" }}
        </h2>
        <input
          v-model="form.nombre"
          type="text"
          placeholder="Nombre"
          class="w-full p-2 mb-2 rounded bg-gray-600 text-white"
        />
        <input
          v-model="form.categoria"
          type="text"
          placeholder="Categoría"
          class="w-full p-2 mb-2 rounded bg-gray-600 text-white"
        />
        <input
          v-model.number="form.precio"
          type="number"
          placeholder="Precio"
          class="w-full p-2 mb-2 rounded bg-gray-600 text-white"
        />
        <div class="flex justify-end gap-2">
          <button
            @click="saveItem"
            class="bg-green-500 text-white px-4 py-2 rounded"
          >
            Guardar
          </button>
          <button
            @click="closeModal"
            class="bg-gray-500 text-white px-4 py-2 rounded"
          >
            Cancelar
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import ProductsProvider from "@/helpers/providers/ProductsProvider";
import AppLoding from "../components/AppLoding.vue";

export default {
  data() {
    return {
      searchQuery: "",
      filterCategory: "",
      sortKey: "",
      sortAsc: true,
      items: [],
      showModal: false,
      editingIndex: null,
      form: {
        nombre: "",
        categoria: "",
        precio: null,
      },
      loading: true,
    };
  },
  mounted() {
    this.cargarProductos();
  },
  computed: {
    uniqueCategories() {
      return [...new Set(this.items.map((item) => item.categoria))];
    },
    filteredItems() {
      let filtered = this.items;

      if (this.searchQuery) {
        filtered = filtered.filter((item) =>
          Object.values(item).some((value) =>
            value
              .toString()
              .toLowerCase()
              .includes(this.searchQuery.toLowerCase())
          )
        );
      }

      if (this.filterCategory) {
        filtered = filtered.filter(
          (item) => item.categoria === this.filterCategory
        );
      }

      if (this.sortKey) {
        filtered.sort((a, b) => {
          let result = 0;
          if (a[this.sortKey] < b[this.sortKey]) result = -1;
          if (a[this.sortKey] > b[this.sortKey]) result = 1;
          return this.sortAsc ? result : -result;
        });
      }

      return filtered;
    },
  },
  components: {
    AppLoding,
  },
  methods: {
    sortTable(key) {
      if (this.sortKey === key) {
        this.sortAsc = !this.sortAsc;
      } else {
        this.sortKey = key;
        this.sortAsc = true;
      }
    },
    openModal(item = null, index = null) {
      if (item) {
        this.form = { ...item };
        this.editingIndex = index;
      } else {
        this.form = { nombre: "", categoria: "", precio: null };
        this.editingIndex = null;
      }
      this.showModal = true;
    },
    closeModal() {
      this.showModal = false;
    },
    saveItem() {
      if (this.editingIndex !== null) {
        this.items[this.editingIndex] = { ...this.form };
      } else {
        this.items.push({ ...this.form });
      }
      this.closeModal();
    },
    deleteItem(index) {
      this.items.splice(index, 1);
    },
    async cargarProductos() {
      try {
        this.items = await ProductsProvider.getProductos();
        this.loading = false;
      } catch (error) {
        console.error("Error al cargar productos:", error);
        this.loading = false;
      }
    },
    async sincronizarProductos() {
      try {
        this.loading = true;
        await ProductsProvider.sincronizarProductos();
        this.loading = false;

        this.cargarProductos();
      } catch (error) {
        console.error("Error al cargar productos:", error);
      }
    },
    async sincronizarProductosMayorista() {
      try {
        this.loading = true;
        await ProductsProvider.sincronizarProductosMayorista();
        this.loading = false;

        this.cargarProductos();
      } catch (error) {
        console.error("Error al cargar productos:", error);
      }
    },
    async pdfProductos() {
      try {
        this.loading = true;
        await ProductsProvider.getProductosPDF();
        this.loading = false;

        this.cargarProductos();
      } catch (error) {
        console.error("Error al cargar productos:", error);
      }
    },
     async pdfProductosMayorista() {
      try {
        this.loading = true;
        await ProductsProvider.getProductosMayoristasPDF();
        this.loading = false;

        this.cargarProductos();
      } catch (error) {
        console.error("Error al cargar productos:", error);
      }
    },
  },
};
</script>
